import { CommonModule, ViewportScroller } from '@angular/common';
import { AfterViewInit, Component, ElementRef, inject, OnInit, Renderer2, ViewChild } from '@angular/core';
// import { CdsAccordionModule } from '@cds/ng-web-components/accordion';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { BrowserHelperService } from '@app/core/services/browser-helper.service';
import { SessionStorageService } from '@app/core/services/session-storage.service';
import { DocumentAccordionComponent } from '@app/shared/components/document-accordion/document-accordion.component';
import { ReloadStateService } from '@app/shared/services/reload-state.service';
import { RequiredDocumentsStateService } from '@app/shared/services/required-documents-state.service';
import { EclaimsAdobeAnalytics } from '@app/shared/utils/adobe/eclaims-adobe-analytics';
import { EclaimsAdobeTags } from '@app/shared/utils/adobe/eclaims-adobe-tags';
import { ActionIcons } from '@cds/ng-themes';
import { CdsButtonModule } from '@cds/ng-web-components/button';
import { CdsIconModule } from '@cds/ng-web-components/icon';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TermsOfServiceComponent } from '../terms-of-service/terms-of-service.component';
import { TokenService } from '@app/core/services/token.service';
import { ConfirmationStateService } from '@app/shared/services/confirmation-state.service';
import { UploadDocumentStateService } from '@app/shared/services/upload-document-state.service';

@Component({
  selector: 'app-e-claims-top-page',
  imports: [CommonModule, TranslateModule, CdsButtonModule, CdsIconModule, DocumentAccordionComponent],
  templateUrl: './e-claims-top-page.component.html',
  styleUrl: './e-claims-top-page.component.scss'
})
export class EClaimsTopPageComponent implements OnInit, AfterViewInit {
  storage = inject(SessionStorageService);
  viewportScroller = inject(ViewportScroller);

  docStateService = inject(RequiredDocumentsStateService);
  @ViewChild('accordionContainer', { read: ElementRef }) accordionContainer!: ElementRef;
  documents: any[] = [];
  reqList: any[] = [];
  closeIconFilled = ActionIcons.button_x_filled;
  plusIcon = ActionIcons.button_plus_filled;
  minusIcon = ActionIcons.button_minus_outlined;
  isInAppBrowser: boolean = false;
  constructor(
    private translate: TranslateService,
    private router: Router,
    private dialog: MatDialog,
    private renderer: Renderer2,
    private browserHelper: BrowserHelperService,
    private reloadStateService: ReloadStateService,
    private tokenService: TokenService,
    private confirmationStateService: ConfirmationStateService,
    private uploadDocumentStateService: UploadDocumentStateService
  ) {
    this.translate.use('ja');
    this.translate.get('TOP_PAGE_REQUEST_POINTS').subscribe((items: any) => {
      this.reqList = items;
    })
  }

  ngOnInit(): void {
    this.scrollToTop();

    this.storage.clear();
    this.docStateService.clearState();
     this.reloadStateService.setReloadChecked(false);

     this.confirmationStateService.reset();
     this.uploadDocumentStateService.resetState();
    EclaimsAdobeAnalytics.trackPageLoad(EclaimsAdobeTags.GUIDANCE.TOP_PAGE_NAME);
     this.tokenService.clearToken();
  }

  ngAfterViewInit(): void {

    // Load documents and control accordion visibility
    setTimeout(() => {
      this.scrollToTop();

      this.translate.get('TOP_PAGE_ACC').subscribe((docs: any[]) => {
        this.documents = docs;
      })
      if (this.documents && this.documents.length > 0) {
        this.showAccordion();
      } else {
        this.hideAccordion();
      }
    }, 200);
  }

  private showAccordion(): void {
    if (!this.accordionContainer) return;

    const element = this.accordionContainer.nativeElement;

    this.renderer.setStyle(element, 'display', 'block');
    this.renderer.setStyle(element, 'opacity', '0');
    this.renderer.setStyle(element, 'transform', 'translateY(-10px)');
    this.renderer.setStyle(element, 'transition', 'opacity 0.3s ease, transform 0.3s ease');

    setTimeout(() => {
      this.renderer.setStyle(element, 'opacity', '1');
      this.renderer.setStyle(element, 'transform', 'translateY(0)');
    }, 10);
  }

  private hideAccordion(): void {
    if (!this.accordionContainer) return;

    const element = this.accordionContainer.nativeElement;
    this.renderer.setStyle(element, 'display', 'none');
    this.renderer.setStyle(element, 'opacity', '0');
    this.renderer.setStyle(element, 'height', '0');
    this.renderer.setStyle(element, 'overflow', 'hidden');
  }


  openDialog() {
    const dialogRef = this.dialog.open(TermsOfServiceComponent, {
      width: '100%',
      height: 'auto',
      maxWidth: '960px',
      maxHeight: '640px',
      panelClass: ['terms-dialog-panel', 'responsive-dialog'],
      data: {
        title: 'Terms & Conditions'
      },
      disableClose: true,
      autoFocus: false,
      restoreFocus: false

    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // Handle dialog result here
        this.reloadStateService.setReloadChecked(true);
        this.router.navigate(['/user-identification']);
      }
    });

    EclaimsAdobeAnalytics.trackLinkClick({
      label: EclaimsAdobeTags.GUIDANCE.TOP_LINK_NAME
    });
  }

  private scrollToTop(): void {
    // Method 1: ViewportScroller (Angular way)
    this.viewportScroller.scrollToPosition([0, 0]);

    // Method 2: Window scroll (immediate)
    window.scrollTo(0, 0);

    // Method 3: Document scroll (fallback for older browsers)
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }

}
